import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../../context/authContext";
import AppContent from "../templates/wrapper/AppContent";
import ChangeProfileForm from "../organisms/forms/changeProfile/ChangeProfileForm";
import { useToast } from "../../hooks/useToast";
import { useDialog } from "../../hooks/useDialog";

export default function ChangeProfile() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const { showToast } = useToast();
  const { showDialog } = useDialog();

  const onSubmit = async (values) => {
    try {
      await authContext.setProfileAttribute(
        values.given_name,
        values.family_name
      );
      await authContext.refreshSession();
      showDialog(
        "",
        t("changeProfile.successPopupTitle"),
        t("dialog.okey"),
        true,
        "",
        "success",
        () => navigate(-1),
        true
      );
    } catch (error) {
      showToast("error", String(error?.message));
    }
  };

  return (
    <>
      <AppContent title={t("home.nameSurname")}>
        <ChangeProfileForm onSubmit={onSubmit} />
      </AppContent>
    </>
  );
}
